module.exports = __webpack_public_path__ + "static/media/icon-macro-training.482aee54.svg";